import React from "react";
import { MapPin, Globe } from "lucide-react";
import { CLINIC_LOCATION_URL, CLINIC_WEBSITE_URL } from "@/lib/constants";

export default function LocationButton() {
  return (
    <div className="fixed right-4 bottom-[80px] lg:bottom-4 z-40 flex flex-row gap-2 items-center">
      <a
        href={CLINIC_WEBSITE_URL}
        target="_blank"
        rel="noreferrer"
        data-testid="clinic-website-btn"
        title="Visita nuestro sitio web"
        className="flex items-center gap-1 h-8 pl-2 pr-2.5 rounded-full font-semibold shadow-md hover:shadow-lg transition-all bg-white/95 backdrop-blur text-[#1F4E78] border border-[#dbe6f1] text-[11px]"
      >
        <Globe size={13} className="shrink-0 text-[#2E6CA4]" />
        <span className="tracking-wide">Sitio web</span>
      </a>
      <a
        href={CLINIC_LOCATION_URL}
        target="_blank"
        rel="noreferrer"
        data-testid="clinic-location-btn"
        title="Nuestra ubicación en Google Maps"
        className="flex items-center gap-1 h-8 pl-2 pr-2.5 rounded-full text-white shadow-md hover:shadow-lg transition-all text-[11px] font-semibold"
        style={{ background: "linear-gradient(135deg, #16A34A 0%, #0F7A38 100%)" }}
      >
        <MapPin size={13} className="shrink-0" />
        <span className="tracking-wide">Ubicación</span>
      </a>
    </div>
  );
}
